import React from 'react';
import { useDispatch } from 'react-redux';

import { discardRenameCard } from 'actions/videosDashboard';
import { ENTER, ESCAPE, TAB } from 'constants/keyCodes';

import useClickOutside from 'hooks/useClickOutside';

import styles from './styles.module.less';

const CardRenameInput = ({ name, onSubmit }) => {
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(name);
  const [initialValue] = React.useState(name);

  const onDiscard = () => dispatch(discardRenameCard());
  const onCommit = () => {
    if (!value.replace(/\s/g, '')) {
      return;
    }

    if (value === initialValue) {
      onDiscard();

      return;
    }

    onSubmit(value);
  };
  const handleKeyPress = e => {
    const keyCode = e.keyCode;

    if (keyCode === ESCAPE) {
      return onDiscard();
    }

    if ([ENTER, TAB].includes(keyCode)) {
      return onCommit();
    }
  };
  const ref = useClickOutside(onCommit);

  React.useEffect(() => ref?.current?.focus(), [ref]);

  return (
    <input
      ref={ref}
      onChange={e => setValue(e.target.value)}
      onClick={e => e.stopPropagation()}
      onFocus={e => e.target.select()}
      onKeyDown={handleKeyPress}
      value={value}
      placeholder="Enter a title"
      className={styles.titleInput}
    />
  );
};

export default CardRenameInput;
